import React from "react";
import { InfoCircle } from "iconsax-react";

const DataNotFound = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center h-96">
        <InfoCircle size={28} color={"grey"} />
        <p className="mt-2 text-xl font-normal text-center font-Proxima opacity-65 ">
          Data Not Found
        </p>
      </div>
    </>
  );
};

export default DataNotFound;
